import { createModalHook } from '../../hooks/useModal'

export const useTotalOwingModal = createModalHook()
